import api from './api';

const service = {
  fetch: params => api.get('whitelists', params),
  fetchById: id => api.get(`whitelists/${id}`),
  whitelist: params => api.post('whitelists', params),
  unwhitelist: id => api.delete(`whitelists/${id}`),
  update: whitelist => api.put(`whitelists/${whitelist.id}`, whitelist),
};

export default service;
